import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-congres-virtuel-programme',
  templateUrl: './congres-virtuel-programme.component.html',
  styleUrls: ['./congres-virtuel-programme.component.scss']
})
export class CongresVirtuelProgrammeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
